/**
 * ENTRAID-315: when a deployed customer's granted Graph permissions need a
 * fresh check. Only a consent verify writes missingPermissions and
 * permissionsCheckedAt, and Onboarding is the only caller, so a customer past
 * onboarding is never checked unless the portal asks.
 */
export const PERMISSIONS_CHECK_MAX_AGE_MS = 24 * 60 * 60 * 1000;

export function needsPermissionCheck(customer, now = Date.now()) {
  if (!customer) return false;
  if (customer.status !== 'deployed' && customer.status !== 'active') return false;
  if (!customer.entraTenantId) return false;
  if (customer.entraConsentResetAt) return false;
  const checked = Date.parse(customer.permissionsCheckedAt ?? '');
  if (Number.isNaN(checked)) return true;
  return now - checked > PERMISSIONS_CHECK_MAX_AGE_MS;
}
